import http from "../../http";

const companyPoint = {
    selectPage(r) {
        return http.get("/gateway/api/sycompany/pc/companyPoint/selectPage", r)
    },
    selectById(r) {
        return http.get("/gateway/api/sycompany/pc/companyPoint/selectById", r)
    },
    save(r) {
        return http.payload("/gateway/api/sycompany/pc/companyPoint/save", r)
    },
    delete(r) {
        return http.post("/gateway/api/sycompany/pc/companyPoint/delete", r)
    },
    selectStaffList(r) {
        return http.get("/gateway/api/sycompany/pc/companyPoint/selectStaffList", r)
    },
    saveStaffList(r) {
        return http.payload("/gateway/api/sycompany/pc/companyPoint/saveStaffList", r)
    },
    selectVisibleList(r) {
        return http.get("/gateway/api/sycompany/pc/companyPoint/selectVisibleList", r)
    },
}

export default companyPoint
